import { Locale } from "react-modern-calendar-datepicker"

export const initialObjectCompanyForm = {
  id: '',
  razaoSocial: '',
  nomeFantasia: '',
  cnpj: '',
  telefoneEmpresa: '',
  usaClinicFrame: false,
  clinicFrameUrl: '',
  clinicFrameApiUrl: '',
  cep: '',
  logradouro: '',
  numero: '',
  complemento: '',
  bairro: '',
  cidade: '',
  estado: '',
  nomeResponsavel: '',
  telefoneResponsavel: '',
  telefoneResponsavel2: '',
  cpfResponsavel: '',
  emailResponsavel: '',
  nomeAdministrador: '',
  cpfAdministrador: '',
  emailAdministrador: '',
  telefoneAdministrador: '',
  telefoneAdministrador2: '',
}

export const initialObjectUnitForm = {
  id: '',
  nomeFantasia: '',
  cnpj: '',
  cep: '',
  logradouro: '',
  numero: '',
  complemento: '',
  cidade: '',
  bairro: '',
  estado: '',
  telefone1: '',
  telefone2: '',
}

export const initialObjectCareLineForm = {
  id: '',
  nome: '',
  idadeInicial: '',
  idadeFinal: '',
  genero: ''
}

export const intervals = [{ nome: '01 mês', id: '1' }, { nome: '02 meses', id: '2' }]
export const formats = [{ nome: 'Texto', id: 'T' }, { nome: 'Numerico', id: 'N' }]
export const genders = [{ nome: 'Masculino', id: 'M' }, { nome: 'Feminino', id: 'F' }, { nome: 'Ambos', id: null }]
export const initialObjectCareLineField = { nome: '', id: '', intervaloMeses: {}, formato: {} }
export const meses = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro',
]

export const ptBrCustomLocale: Locale = {
  // months list by order
  months: meses,

  // week days by order
  weekDays: [
    {
      name: 'Domingo', // used for accessibility 
      short: 'D', // displayed at the top of days' rows
      isWeekend: true, // is it a formal weekend or not?
    },
    {
      name: 'Segunda',
      short: 'S',
    },
    {
      name: 'Terça',
      short: 'T',
    },
    {
      name: 'Quarta',
      short: 'Q',
    },
    {
      name: 'Quinta',
      short: 'Q',
    },
    {
      name: 'Sexta',
      short: 'S',
    },
    {
      name: 'Sábado',
      short: 'S',
      isWeekend: true,
    },
  ],

  // just play around with this number between 0 and 6
  weekStartingIndex: 0,

  // // return a { year: number, month: number, day: number } object
  getToday(gregorainTodayObject) {
    return gregorainTodayObject;
  },

  // // return a native JavaScript date here
  toNativeDate(date) {
    return new Date(date.year, date.month - 1, date.day);
  },

  // // return a number for date's month length
  getMonthLength(date) {
    return new Date(date.year, date.month, 0).getDate();
  },

  // // return a transformed digit to your locale
  transformDigit(digit: any) {
    return digit;
  },

  // texts in the date picker
  nextMonth: 'Próximo mês',
  previousMonth: 'Mês anterior',
  openMonthSelector: 'Selecionar mês',
  openYearSelector: 'Selecionar ano',
  closeMonthSelector: 'Fechar',
  closeYearSelector: 'Fechar',
  defaultPlaceholder: 'Selecione...',

  // for input range value
  from: 'De',
  to: 'Para',


  // used for input value when multi dates are selected
  digitSeparator: ',',

  // if your provide -2 for example, year will be 2 digited
  yearLetterSkip: 0,

  // is your language rtl or ltr?
  isRtl: false,
}

export const toleranciaOptions = [{ nome: '1 dia', id: '1' }, { nome: '2 dias', id: '2' }, { nome: '3 dias', id: '3' }, { nome: '4 dias', id: '4' }, { nome: '5 dias', id: '5' }, { nome: '6 dias', id: '6' }, { nome: '7 dias', id: '7' }];
export const proporcionalidadeOptions = [{ nome: 'Sim', id: 'S' }, { nome: 'Não', id: 'N' }];
export const importFileColaboradorTableData = [
  { column: 'Matricula', type: 'String', format: '', required: 'S', comment: 'Matrícula do colaborador na Empresa' },
  { column: 'Nome', type: 'String', format: '', required: 'S', comment: 'Nome do colaborador. Entre 3 e 150 caracteres' },
  { column: 'Fone', type: 'String', format: '', required: 'S', comment: 'Telefone do colaborador. Entre 10 e 11 caracteres' },
  { column: 'CargoCodigo', type: 'String', format: '', required: 'N', comment: 'Código do cargo do colaborador' },
  { column: 'CargoNome', type: 'String', format: '', required: 'S', comment: 'Nome do cargo do colaborador' },
  { column: 'SetorCodigo', type: 'String', format: '', required: 'N', comment: 'Código do setor do colaborador' },
  { column: 'SetorNome', type: 'String', format: '', required: 'N', comment: 'Nome do setor do colaborador' },
  { column: 'dataAdmissao', type: 'Date', format: 'AAAA-MM-DD', required: 'S', comment: 'Data de admissão do colaborador' },
  { column: 'dataRescisao', type: 'Date', format: 'AAAA-MM-DD', required: 'N', comment: 'Data de rescisão do colaborador' },
  { column: 'dataDesligamento', type: 'Date', format: 'AAAA-MM-DD', required: 'N', comment: 'Data de desligamento' },
  { column: 'filialCodigo', type: 'String', format: '', required: 'N', comment: 'Código da filial onde atua o colaborador' },
  { column: 'filialNome', type: 'String', format: '', required: 'N', comment: 'Nome da filial onde atua o colaborador' },
  { column: 'Sexo', type: 'String', format: '', required: 'S', comment: 'Valores possíveis: F, M' },
  { column: 'postoTrabalho', type: 'String', format: '', required: 'S', comment: 'Posto de Trabalho do colaborador' },
  { column: 'dataNascimento', type: 'String', format: '', required: 'S', comment: 'Data de nascimento (entre 1900 e a data atual)' },
  { column: 'CPF', type: 'String', format: '', required: 'S', comment: 'Entre 11 e 14 caracteres, com ou sem pontuação' },
  { column: 'CEP', type: 'String', format: '', required: 'N', comment: 'Referente ao endereço do colaborador' },
  { column: 'Logradouro', type: 'String', format: '', required: 'N', comment: 'Referente ao endereço do colaborador' },
  { column: 'Número', type: 'String', format: '', required: 'N', comment: 'Referente ao endereço do colaborador' },
  { column: 'Bairro', type: 'String', format: '', required: 'N', comment: 'Referente ao endereço do colaborador' },
  { column: 'Cidade', type: 'String', format: '', required: 'N', comment: 'Referente ao endereço do colaborador' },
  { column: 'Estado', type: 'String', format: '', required: 'N', comment: 'UF válida no Brasil' },
  { column: 'E-mail', type: 'String', format: '', required: 'S', comment: 'E-mail válido' },
  { column: 'EstadoCivil', type: 'String', format: '', required: 'S', comment: 'Valores válidos: Solteiro, Casado, Separado, Divorciado, Viuvo, UniaoEstavel, Outros' },
  { column: 'Cor', type: 'String', format: '', required: 'N', comment: '' },
  { column: 'Nacionalidade', type: 'String', format: '', required: 'N', comment: '' },
  { column: 'Pai', type: 'String', format: '', required: 'N', comment: 'Entre 3 e 150 caracteres' },
  { column: 'mae', type: 'String', format: '', required: 'N', comment: 'Entre 3 e 150 caracteres' },
  { column: 'conjuge', type: 'String', format: '', required: 'N', comment: 'Entre 3 e 150 caracteres' },
  { column: 'registroConselho', type: 'String', format: '', required: 'N', comment: 'Entre 0 e 20 caracteres' },
]

export const importFileDependenteTableData = [
  { column: 'Matricula', type: 'String', format: '', required: 'S', comment: 'Matrícula na Empresa' },
  { column: 'Nome', type: 'String', format: '', required: 'S', comment: 'Nome do dependente. Entre 3 e 150 caracteres' },
  { column: 'Fone', type: 'String', format: '', required: 'S', comment: 'Telefone. Entre 10 e 11 caracteres' },
  { column: 'CargoCodigo', type: 'String', format: '', required: 'N', comment: 'Código do cargo' },
  { column: 'CargoNome', type: 'String', format: '', required: 'N', comment: 'Nome do cargo' },
  { column: 'SetorCodigo', type: 'String', format: '', required: 'N', comment: 'Código do setor' },
  { column: 'SetorNome', type: 'String', format: '', required: 'N', comment: 'Nome do setor' },
  { column: 'dataAdmissao', type: 'Date', format: 'AAAA-MM-DD', required: 'N', comment: 'Data de admissão' },
  { column: 'dataEmancipacao', type: 'Date', format: 'AAAA-MM-DD', required: 'N', comment: 'Data de desligamento' },
  { column: 'dataAfastamento', type: 'Date', format: 'AAAA-MM-DD', required: 'N', comment: 'Data de afastamento' },
  { column: 'dataRetorno', type: 'Date', format: 'AAAA-MM-DD', required: 'N', comment: 'Data de retorno' },
  { column: 'filialCodigo', type: 'String', format: '', required: 'N', comment: 'Código da filial' },
  { column: 'filialNome', type: 'String', format: '', required: 'N', comment: 'Nome da filial' },
  { column: 'Sexo', type: 'String', format: '', required: 'S', comment: 'Sexo do dependente. Valores possíveis: F, M' },
  { column: 'dataNascimento', type: 'String', format: '', required: 'S', comment: 'Data de nascimento (entre 1900 e a data atual)' },
  { column: 'CPF', type: 'String', format: '', required: 'S', comment: 'CPF do dependente. Entre 11 e 14 caracteres, com ou sem pontuação' },
  { column: 'CEP', type: 'String', format: '', required: 'N', comment: 'Referente ao endereço' },
  { column: 'Logradouro', type: 'String', format: '', required: 'N', comment: 'Referente ao endereço' },
  { column: 'Número', type: 'String', format: '', required: 'N', comment: 'Referente ao endereço' },
  { column: 'complemento', type: 'String', format: '', required: 'N', comment: 'Referente ao endereço' },
  { column: 'Bairro', type: 'String', format: '', required: 'N', comment: 'Referente ao endereço' },
  { column: 'Cidade', type: 'String', format: '', required: 'N', comment: 'Referente ao endereço' },
  { column: 'Estado', type: 'String', format: '', required: 'N', comment: 'UF válida no Brasil' },
  { column: 'E-mail', type: 'String', format: '', required: 'N', comment: 'E-mail válido' },
  { column: 'EstadoCivil', type: 'String', format: '', required: 'N', comment: 'Valores válidos: Solteiro, Casado, Separado, Divorciado, Viuvo, UniaoEstavel, Outros' },
  { column: 'Cor', type: 'String', format: '', required: 'N', comment: '' },
  { column: 'Nacionalidade', type: 'String', format: '', required: 'N', comment: '' },
  { column: 'Pai', type: 'String', format: '', required: 'N', comment: 'Entre 3 e 150 caracteres' },
  { column: 'mae', type: 'String', format: '', required: 'N', comment: 'Entre 3 e 150 caracteres' },
  { column: 'conjuge', type: 'String', format: '', required: 'N', comment: 'Entre 3 e 150 caracteres' },
  { column: 'registroConselho', type: 'String', format: '', required: 'N', comment: 'Entre 0 e 20 caracteres' },
  { column: 'TipoDependente', type: 'String', format: '', required: 'N', comment: 'Valores válidos: conjuge ou filho(a)' },
]

export const cidsMock = [{ nome: 'Cólera', id: 'A00' },
{ nome: 'Febres tifoide e paratifoide', id: 'A01' },
{ nome: 'Infecção por salmonella', id: 'A02' },
{ nome: 'Shiguelose', id: 'A03' },
{ nome: 'Outras infecções intestinais bacterianas', id: 'A04' }
]